"use strict";
/**
 * PluginBase.ts
 * Author: David de Regt
 * Copyright: Microsoft 2016
 *
 * Base export for the Web implementation of the plugin.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Video_1 = require("./Video");
exports.default = Video_1.default;
var Types = require("../common/Types");
exports.Types = Types;



//////////////////
// WEBPACK FOOTER
// ./~/reactxp-video/dist/web/PluginBase.js
// module id = 742
// module chunks = 0